const Vue = require("vue");
const Router: any = require("vue-router");

import space from "../pages/space/index.vue";
//import home from "../pages/home/index.vue";

Vue.use(Router);
const routes = [
  {
    path: "/",
    component: space
  }
  // {
  //   path: "/home",
  //   component: home
  // }
];
var router = new Router({
  mode: "history",
  routes
});

export default router;
